import React, { memo } from 'react';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import { time_splitter } from '../Const';
import { splitTime } from '../Convert';
import Paragraph from './Paragraph';
import { Row, Col } from 'react-bootstrap';

type Props = {
  id: string;
  fm_id: number;
  label: string;
  value: string;
  need: boolean;
  disabled: boolean;
  handleChange: (time: string) => void;
  input_assistance?: string;
  placeholder?: string;
  help_msg?: string;
  message?: string;
  handleBlurHour: VoidFunction;
  handleBlurMin: VoidFunction;
  looks_inactive: boolean;
  readonly?: boolean;
};

// 時分
const TimeInput: React.FC<Props> = ({
  id,
  fm_id,
  label,
  value,
  need,
  disabled,
  handleChange,
  input_assistance,
  placeholder,
  help_msg,
  message,
  handleBlurHour,
  handleBlurMin,
  looks_inactive,
  readonly,
}) => {
  // 時入力
  const handleChangeHour = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(`${event.target.value}${time_splitter}${splitTime(value)[1]}`);
  };

  // 分入力
  const handleChangeMin = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(`${splitTime(value)[0]}${time_splitter}${event.target.value}`);
  };

  // placeholderを設定
  const setPlaceholder = () => {
    if (placeholder === null || typeof placeholder === 'undefined' || placeholder.length === 0) {
      return ['', ''];
    }

    const matches = placeholder.match(/^([0-9]+)時([0-9]+)分$/);
    if (matches === null) {
      return ['', ''];
    }

    return [matches[1], matches[2]];
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={
        disabled || looks_inactive ? (
          <Paragraph
            label={
              splitTime(value)[0] !== '' && splitTime(value)[1] !== ''
                ? `${splitTime(value)[0]}時${splitTime(value)[1]}分`
                : ''
            }
          />
        ) : (
          <>
            <Row>
              <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                <input
                  id={`${id}-year`}
                  type="text"
                  className={`form-control ${message && 'textarea-error'}`}
                  disabled={disabled || readonly}
                  maxLength={2}
                  value={splitTime(value)[0]}
                  onChange={handleChangeHour}
                  data-fm_id={fm_id}
                  onBlur={handleBlurHour}
                  placeholder={setPlaceholder()[0]}
                />
              </Col>
              <div className="d-flex align-items-end justify-content-left">時</div>
              <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                <input
                  id={`${id}-months`}
                  type="text"
                  className={`form-control ${message && 'textarea-error'}`}
                  disabled={disabled}
                  maxLength={2}
                  value={splitTime(value)[1]}
                  onChange={handleChangeMin}
                  data-fm_id={fm_id}
                  onBlur={handleBlurMin}
                  placeholder={setPlaceholder()[1]}
                />
              </Col>
              <div className="d-flex align-items-end justify-content-left">分</div>
            </Row>
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default memo(TimeInput);
